/**
 * Route and sidebar entries list the org rights allowed to see them
 * (`allowedRoles`). Those lists are about navigation, not authorization — the
 * real gate is the module matrix on the server plus ModuleGuard on the client.
 *
 * EXTERNAL ("Externista") is an outside collaborator who works on projects but
 * holds nothing on the org plane. Matching it literally would exclude it from
 * every list that says ['OWNER', 'ADMIN', 'USER'] and leave the app with no
 * navigation at all, so for visibility purposes it reads as an ordinary member.
 * Admin-only entries stay out of reach because they never list USER either.
 */
export const navRightsOf = (rights?: string | null): string | undefined =>
  rights === 'EXTERNAL' ? 'USER' : (rights ?? undefined)
